module.exports = __webpack_public_path__ + "static/img/head-pic-01@2x.7678abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/head-pic-01@2x.png
// module id = DO2A
// module chunks = 1